<isp-link
  *ngIf="props.data$ | async as data"
  [caption]="data.caption"
  [target]="data.target"
  [internal]="data.internal"
  [sameTab]="data.sameTab"
  [newTab]="data.newTab"
  [href]="data.href"
  [color]="data.color"
  [img]="data.img"
  (clickEvent)="handleLinkClick($event)"
>
</isp-link>
